<template>
  <div class="user-forget">
    <forget-header :systemName="systemName" pageType="forget" />
    <div class="user-forget-body">
      <div class="formForget">
        <a-steps :current="step">
          <a-step title="填写邮箱" description="" />
          <a-step title="邮箱校验" description="" />
          <a-step title="完成" description="" />
        </a-steps>
        <a-divider dashed/>
        <a-form :form="form">
          <a-form-item label="邮箱" :colon="false" v-bind="formItemLayout" requiredd v-if="step !== 2">
            <a-input
              placeholder="请输入邮箱账号，如 user@xx.com"
              v-model="forgetData.email"
              v-decorator="['email', {rules: [
                { required: true, message: '请输入邮箱'},
                { max: 50, message: '长度不能超过50个字符'}
              ],initialValue: forgetData.email}]" :disabled="step !== 0"/>
          </a-form-item>
          <a-form-item label="验证码" :colon="false" v-bind="formItemLayout" requiredd v-if="step === 1">
            <a-input
              placeholder="请输入验证码"
              v-model="forgetData.validCode"
              v-decorator="['validCode', {rules: [
                { required: true, message: '请输入验证码'},
                { max: 5, message: '长度不能超过5个字符'}
              ],initialValue: forgetData.validCode}]"
              style="width: 50%"/>
              <div class="input-tip">请填写邮箱中验证码邮件中的验证码</div>
          </a-form-item>
          <a-form-item :wrapperCol="{span: 16, offset: 4}" v-if="step !== 2">
            <a-button
              size="large"
              type="primary"
              htmlType="submit"
              class="forget-button"
              :loading="loading"
              @click.stop.prevent="handleSubmit">{{step !== 1 ? '下 一 步': '提交'}}
            </a-button>
            <a-button
              v-if="step === 1"
              style="margin-left: 1.2rem;"
              size="large"
              type="default"
              htmlType="submit"
              class="forget-button"
              :loading="loading"
              @click.stop.prevent="handleSubmitPre">上 一 步
            </a-button>
          </a-form-item>
        </a-form>
        <forget-success v-if="step === 2"></forget-success>
      </div>
    </div>
    <forget-footer :copyright="copyright" :ICP="setting.ICP" />
  </div>
</template>

<script>
import setting from '../../settings.js'
import ForgetHeader from './Header'
import ForgetFooter from './Footer'
import ForgetSuccess from './ForgetSuccess'

const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 }
}
export default {
  name: 'Forget',
  components: {ForgetHeader, ForgetFooter, ForgetSuccess},
  data () {
    return {
      form: this.$form.createForm(this),
      formItemLayout,
      forgetData: {},
      companies: [],
      setting: setting,
      step: 0,
      loading: false
    }
  },
  computed: {
    systemName () {
      return this.$store.state.setting.systemName
    },
    copyright () {
      return this.$store.state.setting.copyright
    }
  },
  methods: {
    handleSubmitPre () {
      this.form.setFieldsValue({
        validCode: ''
      })
      this.forgetData.validCode = ''
      this.step--
    },
    handleSubmit () {
      if (this.step === 0) {
        this.form.validateFields((err, values) => {
          if (!err) {
            let data = {
              source: 'admin',
              email: this.forgetData.email
            }
            this.loading = true
            this.$post('anon/forgot/sendCode', data, true).then((r) => {
              this.loading = false
              this.step++
            }).catch(() => {
              this.loading = false
              this.$message.error('抱歉，发送邮件验证码失败')
            })
          }
        })
      } else if (this.step === 1) {
        this.form.validateFields((err, values) => {
          if (!err) {
            this.loading = true
            let data = {
              source: 'admin',
              email: this.forgetData.email,
              validCode: this.forgetData.validCode
            }
            this.$post('anon/forgot/reset', data, true).then((r) => {
              this.loading = false
              this.step++
            }).catch(() => {
              this.loading = false
              this.$message.error('抱歉，重置密码账号失败')
            })
          }
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .user-forget {
    background-color: #F6F5FA;
    &-body {
      display: flex;
      height: calc(100vh - 5rem);
      align-items: center;
      .formForget {
        width: 80vw;
        max-width: 45rem;
        margin: 0 auto;
        padding: 3.4rem 5.5rem;
        font-size: 1rem;
        background-color: #ffffff;
        box-shadow: 1px 2px 6px 0px rgba(0, 0, 0, 0.13);
        border-radius: 12px;
        /deep/ .ant-divider-horizontal {
          margin: 1.7rem 0 1.7rem 0;
        }
        .ant-form-item {
          margin: .8rem 0 !important;
          /deep/ .ant-input {
            height: 2rem !important;
            color: #272727;
            font-size: .8rem !important;
            line-height: 2rem !important;
          }
        }
      }
      .forget-button {
        width: 7.2rem;
        height: 1.8rem;
        margin-top: 1.2rem;
        font-size: .8rem;
        border-radius: .2rem;
      }
      .ant-btn-primary {
        background-color: #5C86E5;
      }
    }
  }
  /deep/ .ant-form {
    label {
      height: 2rem !important;
      color: #272727;
      font-size: .8rem !important;
      line-height: 2rem !important;
    }
    /deep/ .ant-select-selection {
      height: 2rem !important;
      font-size: .8rem !important;
      line-height: 2rem !important;
    }
    /deep/ .ant-select-selection__rendered {
      height: 2.2rem !important;
      font-size: .8rem !important;
      line-height: 2.2rem !important;
      .ant-select-selection__placeholder {
        top: 45%;
      }
    }
    .ant-form-item-label > label::after {
      margin: 0 .5rem 0 .5rem;
    }
  }
  .input-tip {
    color: #999;
    font-size: 80%;
    line-height: 1.2
  }
</style>



// WEBPACK FOOTER //
// Forget.vue?fabc1aa6